import { FormVisibilityNode } from './getInitialFormItemVisibility';

export const hasFormItemVisibilityExpression = (
  node: FormVisibilityNode
): boolean => {
  if (typeof node.visible === 'string') {
    return true;
  }

  return node.items?.some(hasFormItemVisibilityExpression) ?? false;
};
